<template>
  <vx-card class="upgrade-list">
   <paging-list 
    :data="list" 
    :total="total" 
    :limit="query.limit" 
    :page="query.page" 
    @pageChange="onPageChange"
  >
      <div slot="header" class="top w-full">
        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input class="w-full" label="搜索" placeholder="输入活动名称或ID" v-model="query.keyword"  />
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2">
          <label class="vs-input--label" style="height:14px">时间</label>
            <date-picker range v-model="query.time" />
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <label class="vs-input--label" style="height:14px"></label><br />
            <vs-button class="mr-3 mb-2">
              查询
            </vs-button>
            <vs-button to="/pages/empty" color="primary" type="border" class="mb-4 mr-4 cursor-pointer items-center justify-between font-medium text-base text-primary border border-solid border-primary">
              <icon icon="PlusIcon" svgClasses="h-4 w-4" style="top: 2px" />
              新建
            </vs-button>
          </div>
        </div>
      </div>
      <template slot="thead">
      <vs-th>标题</vs-th>
      <vs-th>更新时间</vs-th>
      <vs-th>编辑人</vs-th>
      <vs-th>操作</vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
        <vs-td>标题</vs-td>
        <vs-td>{{new Date() | datetime}}</vs-td>
        <vs-td>admin</vs-td>
        <vs-td>操作</vs-td>
      </vs-tr>
    </template>
   </paging-list>
  </vx-card>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      total: 0,
      query: {
        time: [],
        keyword: '',
        limit: 10,
        page: 1,
      },
    }
  },
  methods: {
    onPageChange(p) {
      console.log('page change:', p)
    },
  },
}
</script>
